import axiosInstance from '../helpers/axiosInstance';

export const getCustomerApi = async (request) => {
    const response = await axiosInstance.post('staff/customer/v2', request.data);
    return response.data;
};

export const getCustomerDropdownApi = async (pageNo, searchKey) => {
    const url = searchKey !== undefined
        ? `staff/customers?searchKey=${searchKey}&page=${pageNo}`
        : `staff/customers?page=${pageNo}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const createCustomerApi = async (request) => {
    const response = await axiosInstance.post('staff/customers', request.formData);
    return response.data;
};

export const getOneCustomerApi = async (customerId) => {
    const response = await axiosInstance.get(`staff/customers/${customerId}`);
    return response.data;
};

export const updateCustomerApi = async (request) => {
    const response = await axiosInstance.put('staff/customers', request.formData);
    return response.data;
};
